require('./RAStrategyCards.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const Slider = require('react-slick').default;
// @ components
const FormattedTextWithComponents = require('components/FormattedTextWithComponents/FormattedTextWithComponents');
const RAStrategyItem = require('./RAStrategyItem/RAStrategyItem');
// @ constants
const { CARD_ONE, CARD_TWO, CARD_THREE, CARD_FOUR, CARD_FIVE } = require('constants/RAConstants');
// @ utilities
import { formatText, FormattedText } from 'core/i18n';
const classNames = require('classnames');

class RAStrategyCards extends React.Component {
    buildInfo() {
        let contactInfo = null;

        if (this.props.maxAvailable < 5) {
            const infoContact = (
                <div className="ra-strategy-cards__info ra-strategy-cards__info--bold">
                    <FormattedText value="raStrategyCards-raStrategyCards_contact" />
                </div>
            );

            contactInfo = (
                <FormattedTextWithComponents
                    value="raStrategyCards-raStrategyCards_info"
                    className="ra-strategy-cards__info"
                    injectedComponents={[infoContact]}
                />
            );
        }

        return contactInfo;
    }

    render() {
        const {
            selectedCard,
            maxAvailable,
            onSelectStrategy,
            onStrategyDetailsClick,
            firstCardSelected,
            modifyPlan,
            disabled,
        } = this.props;
        const lowRiskText = formatText('raStrategyItem-lowRisk');
        const midRiskText = formatText('raStrategyItem-midRisk');
        const highRiskText = formatText('raStrategyItem-highRisk');
        const midHighRisk = formatText('raStrategyItem-midHighRisk');
        const midLowRisk = formatText('raStrategyItem-midLowRisk');
        const info = this.buildInfo();
        const initialSlideDesktop = selectedCard > 3 ? 2 : 1;
        const initialSlide = selectedCard ? selectedCard : 1;
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 3,
            initialSlide: initialSlideDesktop,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        slickGoTo: initialSlide,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        slickGoTo: initialSlide,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        slickGoTo: initialSlide,
                    },
                },
            ],
        };
        const containerClass = classNames('ra-strategy-cards__container', {
            'ra-strategy-cards__container--disabled': disabled,
        });

        return (
            <div className="ra-strategy-cards">
                <div className={containerClass}>
                    <RAStrategyItem
                        id={CARD_ONE}
                        disabled={CARD_ONE > maxAvailable}
                        firstCardSelected={firstCardSelected}
                        modifyPlan={modifyPlan}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        riskType={lowRiskText}
                        onSelectStrategy={onSelectStrategy}
                        selectedCard={selectedCard}
                    />
                    <RAStrategyItem
                        id={CARD_TWO}
                        disabled={CARD_TWO > maxAvailable}
                        firstCardSelected={firstCardSelected}
                        modifyPlan={modifyPlan}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        riskType={midLowRisk}
                        onSelectStrategy={onSelectStrategy}
                        selectedCard={selectedCard}
                    />
                    <RAStrategyItem
                        id={CARD_THREE}
                        disabled={CARD_THREE > maxAvailable}
                        firstCardSelected={firstCardSelected}
                        modifyPlan={modifyPlan}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        riskType={midRiskText}
                        onSelectStrategy={onSelectStrategy}
                        selectedCard={selectedCard}
                    />
                    <RAStrategyItem
                        id={CARD_FOUR}
                        disabled={CARD_FOUR > maxAvailable}
                        firstCardSelected={firstCardSelected}
                        modifyPlan={modifyPlan}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        riskType={midHighRisk}
                        onSelectStrategy={onSelectStrategy}
                        selectedCard={selectedCard}
                    />
                    <RAStrategyItem
                        id={CARD_FIVE}
                        disabled={CARD_FIVE > maxAvailable}
                        firstCardSelected={firstCardSelected}
                        modifyPlan={modifyPlan}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        riskType={highRiskText}
                        onSelectStrategy={onSelectStrategy}
                        selectedCard={selectedCard}
                    />
                </div>
                <div className="ra-strategy-cards__info-wrapper">{info}</div>
            </div>
        );
    }
}

RAStrategyCards.propTypes = {
    firstCardSelected: PropTypes.number,
    maxAvailable: PropTypes.number.isRequired,
    modifyPlan: PropTypes.bool,
    onStrategyDetailsClick: PropTypes.func,
    onSelectStrategy: PropTypes.func.isRequired,
    selectedCard: PropTypes.number.isRequired,
    title: PropTypes.string,
};

RAStrategyCards.defaultProps = {
    firstCardSelected: 0,
    modifyPlan: false,
    onStrategyDetailsClick: null,
};

module.exports = RAStrategyCards;
